<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="small"
      resizable
      border
      :edit-rules="validRules"
      :edit-config="{
        trigger: 'click',
        mode: 'row',
      }"
      @edit-closed="save"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('from_label_monthly_budget') || '月度预算'
            }}</span>
          </div>
        </slot>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import Math from '@/libs/util.math.js'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    height: { type: Number, default: 300 },
    disabled: { type: Boolean, default: false },
    isUsed: { type: Boolean, default: false },
    packingType: { type: String, default: '' },
    code: { type: String, default: '' },
    expandDisabled: { type: Boolean, default: false },
  },
  mounted() {},
  watch: {
    tableData: {
      handler(val) {
        if (val.length) {
          this.data = this.tableData.slice(0)
        }
      },
      immediate: true,
    },
  },
  computed: {},
  data() {
    return {
      data: [
        {
          month: 1,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 2,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 3,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 4,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 5,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 6,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 7,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 8,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 9,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 10,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 11,
          estimatedQty: 0,
          budgetMonth: 0,
        },
        {
          month: 12,
          estimatedQty: 0,
          budgetMonth: 0,
        },
      ],
      validRules: {
        estimatedQty: [
          {
            type: 'number',
            required: true,
            message: '请输入预计数量',
          },
        ],
        budgetMonth: [
          {
            type: 'number',
            required: true,
            message: '请输入每月预算',
          },
        ],
      },
      visible: false,
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('table_label_month') || '月份',
          field: 'month',
          minWidth: 150,
          align: 'center',
          showOverflow: true,
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_estimated_quantity') || '预计数量',
          field: 'estimatedQty',
          minWidth: 120,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInputNumber',
            props: {
              controlsPosition: 'right',
              style: 'width:100%',
              min: 0,
              step: 1,
              precision: 0,
            },
            placeholder: '请输入',
            immediate: true,
          },
        },
        {
          title: this.$l('table_label_monthly_budget') || '每月预算',
          field: 'budgetMonth',
          minWidth: 120,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInputNumber',
            props: {
              controlsPosition: 'right',
              style: 'width:100%',
              min: 0,
              step: 0.01,
              precision: 2,
            },
            placeholder: this.$l('INDEX.tips_input_placeholder') || '请输入',
            immediate: true,
          },
        },
      ],
    }
  },
  methods: {
    headerCellStyle({ column }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    },
    async getTableData() {
      const result = await this.validEvent()
      if (!result) return result
      return this.$refs.table.getTableData()
    },
    async validEvent() {
      const $table = this.$refs.table
      const errMap = await $table.validate(true).catch((errMap) => errMap)
      if (errMap) {
        return false
      } else {
        return true
      }
    },
    async save() {
      const result = await this.validEvent()
      if (!result) return
      const data = this.$refs.table.getTableData().tableData
      let param = {
        budgetQ1: 0,
        budgetQ2: 0,
        budgetQ3: 0,
        budgetQ4: 0,
        subBudget: 0,
        estimatedQty: 0,
      }
      data.forEach((i) => {
        if (i.month <= 3) {
          param.budgetQ1 = this.add(
            param.budgetQ1,
            i.budgetMonth ? i.budgetMonth : 0
          )
        }
        if (i.month >= 4 && i.month <= 6) {
          param.budgetQ2 = this.add(
            param.budgetQ2,
            i.budgetMonth ? i.budgetMonth : 0
          )
        }
        if (i.month >= 7 && i.month <= 9) {
          param.budgetQ3 = this.add(
            param.budgetQ3,
            i.budgetMonth ? i.budgetMonth : 0
          )
        }
        if (i.month >= 10 && i.month <= 12) {
          param.budgetQ4 = this.add(
            param.budgetQ4,
            i.budgetMonth ? i.budgetMonth : 0
          )
        }
        param.estimatedQty = this.add(
          param.estimatedQty,
          i.estimatedQty ? i.estimatedQty : 0
        )
        param.subBudget = this.add(
          param.subBudget,
          i.budgetMonth ? i.budgetMonth : 0
        )
      })
      this.$emit('updateBudget', param)
    },
    updateBudgetQuarter(num, val) {
      var budgetAvg = this.divideDown(val, 3, 0)
      const data = this.$refs.table.getTableData().tableData
      var lastMonth = this.multiply(num, 3)
      var startMonth = this.subtract(lastMonth, 2)
      data.forEach((i) => {
        if (i.month >= startMonth && i.month < lastMonth) {
          i.budgetMonth = budgetAvg
        }
        if (i.month === lastMonth) {
          i.budgetMonth = this.subtract(val, this.multiply(budgetAvg, 2))
        }
      })
    },
    updateEstimatedQty(val) {
      var estimatedQtyAvg = this.divideDown(val, 12, 0)
      const data = this.$refs.table.getTableData().tableData
      data.forEach((i) => {
        if (i.month < 12) {
          i.estimatedQty = estimatedQtyAvg
        }
        if (i.month === 12) {
          i.estimatedQty = this.subtract(
            val,
            this.multiply(estimatedQtyAvg, 11)
          )
        }
      })
    },
    //加
    add(x, y) {
      x = x || 0
      y = y || 0
      return Math.number(Math.add(Math.bignumber(x), Math.bignumber(y)))
    },
    //减
    subtract(x, y) {
      x = x || 0
      y = y || 0
      return Math.number(Math.subtract(Math.bignumber(x), Math.bignumber(y)))
    },
    //除
    divide(x, y) {
      if (!y) return 0
      return Math.number(Math.divide(Math.bignumber(x), Math.bignumber(y)))
    },
    divideDown(x, y, l = 4) {
      if (!y) return 0
      return this.roundDown(this.divide(x, y), l)
    },
    //乘
    multiply(x, y) {
      if (!x || !y) return 0
      return Math.number(Math.multiply(Math.bignumber(x), Math.bignumber(y)))
    },
    roundDown(x, y = 2) {
      if (!x) return 0
      const fixed = Math.pow(10, y)
      return this.divide(Math.floor(this.multiply(x, fixed)), fixed)
    },
  },
}
</script>
